<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card grid-list-md>
      <ModelTitle title="Assign Department" @close="close()" />
      <v-card-text v-if="SelectedClass">
        <v-row>
          <v-col cols="12" sm="12">
            <div>
              Class:
              <span class="font-weight-bold text-capitalize">{{
                SelectedClass.name
              }}</span>
            </div>
            <div>
              Fee:
              <span class="font-weight-bold text-capitalize">{{
                SelectedClass.defaultFee | currency
              }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="12">
            <v-autocomplete
              dense
              autofocus
              hide-details
              :items="Students"
              clearable
              item-text="fullName"
              v-model="selectedStudent"
              return-object
              item-value="id"
              label="Select Student"
              outlined
              ><template slot="item" slot-scope="{ item }">
                <span>{{ item.fullName }}</span>
                <v-spacer></v-spacer>
                <v-chip color="grey lighten-3">
                  <v-avatar left class="grey lighten-2">
                    <v-icon small>mdi-google-classroom</v-icon>
                  </v-avatar>
                  <span>{{ item.classCount }}</span>
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text v-if="selectedStudent">
        <v-row align="center">
          <v-col cols="12" sm="12" md="6" offset-md="6">
            <v-text-field
              outlined
              dense
              readonly
              hide-details
              @focus="$event.target.select()"
              class="right-input"
              v-model="fee"
              label="Fee"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" offset-md="6">
            <v-text-field
              outlined
              dense
              hide-details
              @focus="$event.target.select()"
              class="right-input"
              v-model="discount"
              label="Discount"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" offset-md="6">
            <v-text-field
              outlined
              dense
              hide-details
              @focus="$event.target.select()"
              class="right-input"
              v-model="parentPay"
              label="Parent Pay"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-if="selectedStudent">
        <div>
          {{ selectedStudent.fullName }} fee will be
          {{ balancePayment | currency }} a month. And
          {{ sponsor | currency }} will be collected by sponsor.
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="green lighten-1" :loading="loading" dark @click="submit()"
          >save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import classesService from "@/modules/Classes/service.js";
import studentService from "@/modules/Student/service.js";

export default {
  props: {
    editDialog: {
      default: false,
    },
    SelectedClass: {
      type: Object,
    },
  },
  name: "Assign-Class-to-student",
  data() {
    return {
      Students: [],
      selectedStudent: null,
      loading: false,
      dialog: false,
      fee: 0,
      discount: 0,
      sponsor: 0,
      parentPay: 0,
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    balancePayment() {
      return this.fee - this.discount - this.sponsor;
    },
  },
  watch: {
    editDialog(val) {
      this.dialog = val;
    },
    selectedStudent(val) {
      console.log("val in selected ", val);
      if (val) {
        this.fee = this.SelectedClass.defaultFee;
        this.parentPay = this.SelectedClass.defaultFee;
      }
    },
    discount(val) {
      this.parentPay = this.fee - val;
    },
    parentPay(val) {
      this.sponsor = this.fee - this.discount - val;
    },
    dialog(val) {
      if (val) {
        this.getStudent();
      }
    },
  },
  methods: {
    deleteRow(row) {
      console.log("row", row);
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          if (row.StudentTeacher) {
            classesService
              .removeStudent(row.StudentTeacher.id)
              .then((response) => {
                if (response.data) {
                  const studentId = (element) => element.id === row.id;

                  let i = this.StudentList.findIndex(studentId);
                  this.StudentList.splice(i, 1);
                  this.$swal(
                    "Remove!",
                    "Student has been remove from this teacher.",
                    "success"
                  );
                  // this.getList();
                }
              });
          }
        }
      });
    },
    async submit() {
      let obj = {
        ClassId: this.SelectedClass.id,
        StudentId: this.selectedStudent.id,
        fee: this.fee,
        discount: this.discount,
        sponsor: this.sponsor,
        parentPay: this.parentPay,
      };
      classesService
        .assignStudent(obj)
        .then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Student was assist to class",
            });
          this.empty();
          this.$emit("submit");
        })
        .catch((err) => {
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });

      this.selectedStudent = null;
    },
    getStudent() {
      return studentService.getAll({studentsWithoutClass: true}).then((response) => {
        this.Students = response.data;
        console.log("response Students", this.Students);

        return response;
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.selectedStudent = null;
      this.fee = 0;
      this.discount = 0;
      this.sponsor = 0;
      this.parentPay = 0;
    },
  },
};
</script>

<style scoped></style>
